import { Braces } from 'lucide-react'

interface JsonEditorProps {
    value: string
    onChange: (val: string) => void
    label?: string
}

export function JsonEditor({ value, onChange, label = "LLM Params (JSON)" }: JsonEditorProps) {
    const isValid = () => {
        try {
            JSON.parse(value)
            return true
        } catch {
            return false
        }
    }

    return (
        <div className="p-4 bg-white/5 border border-white/10 rounded-lg">
            <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2 text-purple-400">
                    <Braces className="w-4 h-4" />
                    <h3 className="text-sm font-semibold">{label}</h3>
                </div>
                <span className={`text-[10px] px-2 py-0.5 rounded ${isValid() ? 'bg-green-500/20 text-green-300' : 'bg-red-500/20 text-red-300'}`}>
                    {isValid() ? 'Valid JSON' : 'Invalid JSON'}
                </span>
            </div>

            <textarea
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="w-full h-32 px-3 py-2 bg-black/50 border border-white/10 rounded font-mono text-xs text-green-400 focus:outline-none focus:border-purple-500"
                spellCheck={false}
            />
        </div>
    )
}
